import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularHelperService from '../../services/angular-helper.service';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'item-rating',
	templateUrl: './item-rating.component.html',
	imports: [ CommonModule, FormsModule ]
})
export class ItemRatingComponent implements OnInit, OnDestroy {
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	
	@Input() size: any | undefined;
	@Input() model: any;
	@Input() maxRating: any | undefined;
	
	vm: any = undefined;
	timer: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.ratings = new Array(this.vm.maxRating || 5);
		this.getRoundedValue();
		
		var currentRating = undefined;
		this.timer = this.angularHelperService.createInterval(() => {
			if (this.vm.model !== currentRating) {
				currentRating = this.vm.model;
				this.getRoundedValue();
			}
		}, 500);
	}
	
	ngOnDestroy() {
		if (this.timer) {
			this.angularHelperService.cancelInterval(this.timer);
		}
	}
	
	getRoundedValue() {
		this.vm.roundValue = Math.round(this.vm.model * 2) / 2;
	}
	
}